<template>
    <el-button
            :size="size"
            style="width: 100px"
            :disabled="!canSendCode"
            @click="sendCode"><span v-text="sendBtnText"></span>
    </el-button>
</template>
<script>
    export default {
        props: {
            size: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: '发送短信'
            }
        },
        data() {
            return {
                canSendCode: true,
                sendBtnText: this.text,
                interval: null,
            }
        },
        beforeDestroy() {
            this.endCountdown()
        },
        methods: {
            sendCode() {
                this.canSendCode = false;
                this.countdown();
                this.$emit('my-click', {err: () => this.endCountdown()})
            },
            countdown() {
                let time = 30;
                this.sendBtnText = `${time}s`;
                this.interval = setInterval(() => {
                    time--;
                    this.sendBtnText = `${time}s`;
                    if (time <= 0) {
                        this.endCountdown()
                    }
                }, 1000);
            },
            endCountdown() {
                clearInterval(this.interval);
                this.sendBtnText = this.text;
                this.canSendCode = true;
            }
        }
    }
</script>